import { createSlice } from '@reduxjs/toolkit';

// 2ECOMP: PremiumUI Refresh — hiddenDeviceIds persistido em localStorage
const HIDDEN_DEVICES_KEY = 'hiddenDeviceIds';
const loadHiddenDeviceIds = () => {
  try {
    const stored = localStorage.getItem(HIDDEN_DEVICES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};
const saveHiddenDeviceIds = (ids) => {
  try {
    localStorage.setItem(HIDDEN_DEVICES_KEY, JSON.stringify(ids));
  } catch {
    // silently fail
  }
};

const { reducer, actions } = createSlice({
  name: 'devices',
  initialState: {
    items: {},
    selectedId: null,
    followPopupDeviceIds: [], // 2ECOMP: follow popup — IDs dos devices com popup aberto
    hiddenDeviceIds: loadHiddenDeviceIds(), // 2ECOMP: PremiumUI Refresh — devices ocultos no mapa
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach((item) => state.items[item.id] = item);
      // 2ECOMP: follow popup — limpar popups de devices que não existem mais
      state.followPopupDeviceIds = state.followPopupDeviceIds.filter(
        (id) => id in state.items,
      );
    },
    // 2ECOMP: Igual ao Traccar oficial - sobrescreve diretamente
    // Seguro: não perde nenhuma atualização de device
    update(state, action) {
      action.payload.forEach((item) => {
        state.items[item.id] = item;
      });
    },
    selectId(state, action) {
      state.selectTime = Date.now();
      state.selectedId = action.payload;
    },
    remove(state, action) {
      delete state.items[action.payload];
      // 2ECOMP: follow popup — limpar se device removido
      state.followPopupDeviceIds = state.followPopupDeviceIds.filter(
        (id) => id !== action.payload,
      );
    },
    // 2ECOMP: follow popup — abrir popup para um device
    addFollowPopup(state, action) {
      const deviceId = action.payload;
      if (
        !state.followPopupDeviceIds.includes(deviceId)
        && state.followPopupDeviceIds.length < 10 // máximo 10 popups simultâneos
      ) {
        state.followPopupDeviceIds.push(deviceId);
      }
    },
    // 2ECOMP: follow popup — fechar popup de um device
    removeFollowPopup(state, action) {
      state.followPopupDeviceIds = state.followPopupDeviceIds.filter(
        (id) => id !== action.payload,
      );
    },
    // 2ECOMP: PremiumUI Refresh — toggle visibilidade de device no mapa
    toggleDeviceVisibility(state, action) {
      const deviceId = action.payload;
      const idx = state.hiddenDeviceIds.indexOf(deviceId);
      if (idx >= 0) {
        state.hiddenDeviceIds.splice(idx, 1);
      } else {
        state.hiddenDeviceIds.push(deviceId);
      }
      saveHiddenDeviceIds(state.hiddenDeviceIds);
    },
    // 2ECOMP: PremiumUI Refresh — toggle visibilidade do grupo inteiro (igual GPSWOX)
    toggleGroupVisibility(state, action) {
      const { deviceIds } = action.payload;
      const hiddenSet = new Set(state.hiddenDeviceIds);
      // Se TODOS visíveis → ocultar todos; se ALGUM oculto → mostrar todos
      const allVisible = deviceIds.every((id) => !hiddenSet.has(id));
      if (allVisible) {
        deviceIds.forEach((id) => hiddenSet.add(id));
      } else {
        deviceIds.forEach((id) => hiddenSet.delete(id));
      }
      state.hiddenDeviceIds = Array.from(hiddenSet);
      saveHiddenDeviceIds(state.hiddenDeviceIds);
    },
    // 2ECOMP: PremiumUI Refresh — mostrar todos os devices (limpar ocultos)
    setAllDevicesVisible(state) {
      state.hiddenDeviceIds = [];
      saveHiddenDeviceIds([]);
    },
  },
});

export { actions as devicesActions };
export { reducer as devicesReducer };